import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { IMeetingArchiveNoteFormProps } from './types';
import { FormTextInput } from '../../inputs/TextInput';
import { updateSession } from '../../../../../app/page/page-storage/sessions/sessions.actions';
import { closeDialog } from '../../../../../app/dialog/dialog.actions';

export const MeetingArchiveNoteForm: FunctionComponent<IMeetingArchiveNoteFormProps> = ({ archive }) => {
  const dispatch = useDispatch();

  const formProps = useForm();

  const onSubmit = (data: { note: string | null }) => {
    if (data.note?.trim().length === 0) {
      data.note = null;
    }

    dispatch(updateSession(archive.id, { note: data.note }));
    dispatch(closeDialog('meetingArchiveNoteFormDialog'));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="meetingArchiveNoteFormDialog-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as { note: string | null }))}
        method="post"
      >
        <div className="field-container">
          <FormTextInput
            id="note"
            name="note"
            type="text"
            defaultValue={archive.note}
            label="Enter a note"
            placeholder="Enter a note"
            multi
          />
        </div>
      </form>
    </FormProvider>
  );
};
